import React from 'react';
import { NextSeo } from 'next-seo';
import { NextPage } from 'next';
import { asyncActions } from '@docavenue/core';
import RegisterPage from '../components/templates/LoginRegister/Register';
import { useTranslation } from '@/src/i18n';
import { patientTokensActions } from '@/src/actions';
import { wrapper } from '@/src/store';
import waitSagaMiddleware from '@/src/ssr/waitSagaMiddleware';

type Props = {
  mobilePhoneNumber?: string;
};

const Register: NextPage<Props> = ({ mobilePhoneNumber }) => {
  const { t } = useTranslation();

  return (
    <>
      <NextSeo
        title={t('seo-title_register')}
        description={t('seo-description_register')}
      />
      <RegisterPage patientPhoneNumber={mobilePhoneNumber} />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps<Props>(
  store => async ({ query: { linkToken, appointmentId, documentId } }) => {
    if (!(linkToken && (appointmentId || documentId))) {
      return {
        props: {},
      };
    }
    if (appointmentId || documentId) {
      try {
        const patient = await asyncActions(
          store.dispatch,
          patientTokensActions.getOne(linkToken, {
            appointmentId,
            documentId,
          }),
        );
        await waitSagaMiddleware(store);
        const { mobilePhoneNumber } = patient;
        return { props: { mobilePhoneNumber: mobilePhoneNumber || null } };
      } catch (e) {
        // Just ignore error
      }
    }
    return {
      props: {},
    };
  },
);

export default Register;
